import { render, staticRenderFns } from "./OnboardingAgeError.vue?vue&type=template&id=10440b45&"
import script from "./OnboardingAgeError.vue?vue&type=script&lang=js&"
export * from "./OnboardingAgeError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports